"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sY = exports.sX = exports.pY = exports.pX = exports.mY = exports.mX = void 0;
exports.mX = {
  patterns: {
    '*': '{{value}}'
  },
  properties: ['marginLeft', 'marginRight']
};
exports.mY = {
  patterns: {
    '*': '{{value}}'
  },
  properties: ['marginTop', 'marginBottom']
};
exports.pX = {
  patterns: {
    '*': '{{value}}'
  },
  properties: ['paddingLeft', 'paddingRight']
};
exports.pY = {
  patterns: {
    '*': '{{value}}'
  },
  properties: ['paddingTop', 'paddingBottom']
};
exports.sX = {
  parent: '& > :not([hidden]) ~ :not([hidden])',
  patterns: {
    '*': '{{value}}'
  },
  properties: 'marginLeft'
};
exports.sY = {
  parent: '& > :not([hidden]) ~ :not([hidden])',
  patterns: {
    '*': '{{value}}'
  },
  properties: 'marginTop'
};